document.addEventListener("click", async (event) => {
  const button = event.target.closest("[data-copy]")
  if (!button) return

  event.preventDefault()
  await navigator.clipboard.writeText(button.dataset.copy || button.href)

  const copied = button.querySelector("[data-copied]")
  copied?.classList.remove("hidden")
  setTimeout(() => copied?.classList.add("hidden"), 1500)
})
